import { render, staticRenderFns } from "./alarm_centrals.vue?vue&type=template&id=a0af9726"
import script from "./alarm_centrals.vue?vue&type=script&lang=js"
export * from "./alarm_centrals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports